import { render } from "./StaffAdd.vue?vue&type=template&id=21515149&scoped=true"
import script from "./StaffAdd.vue?vue&type=script&lang=js"
export * from "./StaffAdd.vue?vue&type=script&lang=js"

import "./StaffAdd.vue?vue&type=style&index=0&id=21515149&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-21515149"

export default script